export enum ProjectStatus {
    Pending = "Pending",
    Cancelled = "Cancelled",
    Completed = "Completed",
    InProgress = "In Progress",
    Submitted = "Submitted",
    Approved = "Approved",
    Rejected = "Rejected",
}
